module.exports = __webpack_public_path__ + "img/Lasagna_Meal_Chicken_Pesto.1385e881.jpg";